// Vervangt de lelijke, niet-professionele standaard browserbubbel ("Please
// fill out this field.") die verschijnt bij een <input required> in een leeg
// veld. Alle forms in de app zetten noValidate zodat de browser die bubbel
// nooit meer toont, en roepen in plaats daarvan validateRequiredFields()
// aan bovenaan hun submit-handler. Bij een leeg verplicht veld krijgt dat
// veld een rode rand (.field-invalid, zie index.css) en tonen we onze eigen
// .error-message met een nette, vertaalde melding - net als de rest van de app.

/**
 * Zoekt het eerste lege/onafgevinkte verplichte veld binnen een form-element.
 * @param {HTMLFormElement} formEl
 * @returns {HTMLElement|null}
 */
export function getFirstInvalidField(formEl) {
  if (!formEl || typeof formEl.querySelectorAll !== 'function') return null;

  const fields = Array.from(formEl.querySelectorAll('[required]'));
  return (
    fields.find((el) => {
      if (el.disabled) return false;
      if (el.type === 'checkbox' || el.type === 'radio') return !el.checked;
      return !el.value || !String(el.value).trim();
    }) || null
  );
}

/**
 * Valideert alle [required] velden in het form. Markeert het eerste lege veld
 * visueel (rode rand) en geeft er focus aan. Geeft true terug als alles is
 * ingevuld, anders false.
 * @param {HTMLFormElement} formEl
 * @returns {boolean}
 */
export function validateRequiredFields(formEl) {
  if (!formEl) return true;

  // Vorige markeringen eerst wegvegen, zodat enkel nog-steeds-lege velden
  // een rode rand behouden.
  Array.from(formEl.querySelectorAll('.field-invalid')).forEach((el) =>
    el.classList.remove('field-invalid')
  );

  const invalid = getFirstInvalidField(formEl);
  if (invalid) {
    invalid.classList.add('field-invalid');
    invalid.focus();
    return false;
  }
  return true;
}

/**
 * Handler om op een form te zetten (onInput={clearFieldInvalid}) zodat de
 * rode rand meteen verdwijnt zodra de gebruiker een gemarkeerd veld begint
 * in te vullen.
 */
export function clearFieldInvalid(e) {
  const el = e.target;
  if (el && el.classList) {
    el.classList.remove('field-invalid');
  }
}
